import { HorizontalTabs } from "../../../../components/HorizontalTabs";
import { VerticalTabs } from "../../../../components/VerticalTabs";
import { PermissionForm } from "../PermissionForm";
import { TabTypes } from "./Tabs.types";
import { MembersContainer, PermissionsContainer } from "./Tabs.styles";
import { MembersTab } from "./MembersTab";

export const Tabs: React.FC<TabTypes> = ({
  rolePermissions,
  setRolePermissions,
  handleAddTeamMember,
  members = [],
  selectedRows,
  handleDeleteSelected,
  role,
}) => {
  const vTabs = [
    {
      name: "Member Admin",
      content: (
        <PermissionForm
          type={"Member Admin"}
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      ),
    },
    {
      name: "Teams Admin",
      content: (
        <PermissionForm
          type={"Teams Admin"}
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      ),
    },
    {
      name: "Roles Admin",
      content: (
        <PermissionForm
          type={"Roles Admin"}
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      ),
    },
    {
      name: "Offices Admin",
      content: (
        <PermissionForm
          type={"Offices Admin"}
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      ),
    },
    {
      name: "Companies Admin",
      content: (
        <PermissionForm
          type={"Companies Admin"}
          rolePermissions={rolePermissions}
          setRolePermissions={setRolePermissions}
        />
      ),
    },
  ];

  const hTabs = [
    {
      name: "Permissions",
      content: (
        <PermissionsContainer>
          <VerticalTabs tabs={vTabs} />
        </PermissionsContainer>
      ),
    },
    {
      name: "Members",
      content: (
        <MembersContainer>
          <MembersTab
            members={members}
            handleAddTeamMember={handleAddTeamMember}
            selectedRows={selectedRows}
            handleDeleteSelected={handleDeleteSelected}
            role={role}
          />
        </MembersContainer>
      ),
    },
  ];

  return <HorizontalTabs tabs={hTabs} />;
};
